class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };

    // If the panel is marked hidden in markup, remove the attribute after initialization
    // so CSS transitions can run and JS will control visibility with the .open class.
    if (this.elements.panel && this.elements.panel.hasAttribute('hidden')) {
      this.elements.panel.removeAttribute('hidden');
      // ensure it's collapsed initially
      this.elements.panel.classList.remove('open');
    }

    this.elements.button.addEventListener('click', this.openSelector.bind(this));

    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

    this.elements.button.addEventListener('mouseenter', () => {
      this.cancelClose();
      this.openSelectorHover();
    });

    this.elements.button.addEventListener('mouseleave', () => {
      this.scheduleClose();
    });

    this.elements.panel.addEventListener('mouseenter', () => {
      this.cancelClose();
    });

    this.elements.panel.addEventListener('mouseleave', () => {
      this.scheduleClose();
    });

  }
  
  scheduleClose() {
    if (window.matchMedia('(min-width: 768px)').matches) {
    this.cancelClose();

    this.closeTimer = setTimeout(() => {
      this.hidePanel();
    }, 250);
  }
  }

  cancelClose() {
    if (window.matchMedia('(min-width: 768px)').matches) {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    }
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.classList.remove('open');
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    const isOpen = this.elements.panel.classList.toggle('open');
    this.elements.button.setAttribute('aria-expanded', isOpen.toString());
  }
  openSelectorHover() {
    if (window.matchMedia('(min-width: 768px)').matches) {
      this.elements.button.focus();
      const isOpen = this.elements.panel.classList.toggle('open');
      this.elements.button.setAttribute('aria-expanded', isOpen.toString());
    }
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }

  
}

customElements.define('localization-form', LocalizationForm);